import axios from "axios";

export const handleRecentBlog = async (apiSlug) => {
  try {
    const res = await axios.get(
      process.env.NEXT_PUBLIC_BASE_URL +
        `/api/v1/posts?recent=true&subcategory_id=${apiSlug}`,
    );
    return res?.data?.data?.data;
  } catch {
    return [];
  }
};
